// extracted by mini-css-extract-plugin
export default {"wrapper":"InviteSignup_wrapper__6zI+K","orText":"InviteSignup_orText__owHpc","terms_and_condition":"InviteSignup_terms_and_condition__MCMrh","imgIcon":"InviteSignup_imgIcon__ylKfF"};